import React from 'react';
import SolutionInstallFailContainer from 'containers/SolutionInstallFailContainer';

export default function SolutionInstallFailPage() {
  return <SolutionInstallFailContainer />;
}
